import { makeStyles } from '@material-ui/core/styles';

export const useChangeProductStyles = makeStyles(() => ({
  container: {
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    width: '100%',
    padding: (props) => (props.mobile ? '' : '30px 70px'),
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
  },
  button: {
    maxWidth: 200,
    margin: '0 auto',
  },
  loader: {
    height: 80,
    width: 80,
  },
  divButtonLoading: {
    margin: 'auto',
  },
  optionsTitle: {
    marginTop: '20px',
  },
}));

export const useChangeExtraOptionsStyles = makeStyles((theme) => ({
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'stretch',
    margin: '10px 0',
  },
  radioContainer: {
    alignSelf: 'center',
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'self-start',
    margin: '10px',
  },
  radio: {
    color: `${theme.palette.primary.main}`,
    '&.MuiRadio-colorSecondary.Mui-checked': {
      color: `${theme.palette.primary.main}`,
    },
    '&.MuiRadio-colorSecondary.Mui-checked.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
}));
